<nav class="navbar navbar-expand-lg fixed-top">
  <div class="container" style="position: relative;">
    <a class="navbar-brand mx-5" style="color: rgb(118,168,255)" routerLink="/">
      <img *ngIf="isDarkTheme!=undefined && isDarkTheme" src="assets/logo/logo-france-finance.svg" style="margin-right:15px" alt="logo" [ngClass]="{'float-left': true,'shrink':shrink||navbarToggled}">
      <img *ngIf="isDarkTheme!=undefined && !isDarkTheme" src="assets/logo/logo-france-finance.svg" style="margin-right:15px" alt="logo" [ngClass]="{'float-left': true,'shrink':shrink||navbarToggled}">
    </a>
    <a class="navbar-toggler" data-toggle="collapse" data-target="#navbarNav" (click)="onToggleNavbar()"
      aria-controls="navbarSupportedContent20" aria-expanded="false" aria-label="Toggle navigation">
      <div [ngClass]="{'animated-icon1':true,'open':navbarToggled}"><span></span><span></span><span></span></div>
    </a>
    <div [ngClass]="{'collapse navbar-collapse':true, 'shrink':shrink||navbarToggled}" id="navbarNav">
      <ul class="navbar-nav ml-auto">
        <li *ngIf="user" class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/home" (click)="setPageTitle( 'Home' )">Home</a>
        </li>
        <li *ngIf="user" class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/tools" (click)="setPageTitle( 'Tools' )">Tools</a>
        </li>
        <li *ngIf="user" class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/resources" (click)="setPageTitle( 'Resources' )">Resources</a>
        </li>
        <li *ngIf="user" class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/database" (click)="setPageTitle( 'Funds' )">Funds</a>
        </li>
        <li *ngIf="user" class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/support" (click)="setPageTitle( 'Support' )">Support</a>
        </li>
        <li *ngIf="!user" class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true">Connection</a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLinkActive="active" routerLink="sign-in" (click)="setPageTitle( 'Sign in' )">Sign in</a>
            <a class="dropdown-item" routerLinkActive="active" routerLink="register" (click)="setPageTitle( 'Register' )">Register</a>
            <a class="dropdown-item" routerLinkActive="active" (click)="onThemeChange()">Dark/Light mode</a>
            <div class="col text-center">
              <i class="material-icons align-middle">wb_sunny</i>
              <mat-slide-toggle class="mx-2" (toggleChange)="onThemeChange()" [checked]="isDarkTheme"></mat-slide-toggle>
              <i class="material-icons align-middle">brightness_3</i>
            </div>
          </div>
        </li>
        <li *ngIf="user" class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true">Connection</a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLinkActive="active" (click)="onSignOut()">Sign out</a>
            <a class="dropdown-item" routerLinkActive="active" (click)="onThemeChange()">Dark/Light mode</a>
            <div class="col text-center">
              <i class="material-icons align-middle">wb_sunny</i>
              <mat-slide-toggle class="mx-2" (toggleChange)="onThemeChange()" [checked]="isDarkTheme"></mat-slide-toggle>
              <i class="material-icons align-middle">brightness_3</i>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>

<div [ngClass]="{'container nav-offset': true,'shrink-offset':shrinkOffset}"></div>
